export function downloadAccidentContract(id) {
    return axios({
        url: `/api/test/insurance/accident/contract/take`,
        method: 'post',
        data: {
            contractId: id,
        },
    });
}
